import React, { useState } from "react";
import { Pressable, Text, StyleSheet } from "react-native";
import { Ionicons } from "@expo/vector-icons";

function HousePickButton({ onPress, label = "House Pick!", containerStyle }) {
  const [isPressed, setIsPressed] = useState(false);

  return (
    <Pressable
      onPress={onPress}
      onPressIn={() => setIsPressed(true)}
      onPressOut={() => setIsPressed(false)}
      style={[
        styles.button,
        containerStyle,
        isPressed && styles.buttonPressed,
      ]}
    >
      <Ionicons
        name="dice-outline"
        size={22}
        color="black"
      />
      <Text
        numberOfLines={1}
        style={[
          styles.buttonText,
          isPressed && styles.buttonTextPressed,
        ]}
      >
        {label}
      </Text>
    </Pressable>
  );
}

const styles = StyleSheet.create({
  button: {
    flexDirection: "row",
    alignItems: "center",
    justifyContent: "center",
    height: 44,
    backgroundColor: "#FFFFFF",
    borderWidth: 2,
    borderColor: "#d3d3d3",
    borderRadius: 999,
    paddingHorizontal: 12,
    shadowColor: "#000",
    shadowOffset: { width: 0, height: 2 },
    shadowOpacity: 0.25,
    shadowRadius: 3.84,
    elevation: 5,
  },
  buttonPressed: {
    backgroundColor: "#F3F3F3",
  },
  buttonText: {
    marginLeft: 6,
    fontSize: 15,
    lineHeight: 20,
    fontWeight: "700",
    color: "#000000",
    fontFamily: "AbhayaLibre_700Bold, serif",
  },
  buttonTextPressed: {
    color: "#000000",
  },
});

export default HousePickButton;
